import CustomerUptimeStatusResourceModel from '../../generated/types/model/resource/CustomerUptimeStatusResourceModel';

export default class CustomerUptimeStatusResourceViewModel extends CustomerUptimeStatusResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
